export class ProductLabelDto {
  labelType: string;
  labelText: string;
  id?: string;

  constructor(d?: ProductLabelDto) {
    if (!d) {
      return;
    }

    this.labelType = d.labelType;
    this.labelText = d.labelText;
    this.id = d.id;
  }
}
